// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Aq-z","imageAndVideoCount":"Bq-z","imageAndVideoContainer":"Cq-z","viewAllReviews":"Dq-z"};